<template>
  <div class="table-page-search-wrapper">
    <a-modal title="数据导出" :width="width" :visible="visible" @cancel="open(false)" :maskClosable="false">
      <template slot="footer">
        <a-button key="back" @click="clearSearch">重置</a-button>
        <a-button key="submit" type="primary" :loading="btnLoading" @click="handleExport">
          导出
        </a-button>
      </template>
      <a-spin tip="文件导出中,请稍后..." :spinning="spinning">
        <a-form>
          <a-row :gutter="48">
            <a-col :span="24">
              <a-form-item>
                <a-select
                  :allowClear="true"
                  v-model="searchModel.roleIds"
                  mode="multiple"
                  :maxTagCount="3"
                  showSearch
                  optionFilterProp="children"
                  :filterOption="filterOption"
                  placeholder="请选择角色"
                >
                  <a-select-option v-for="(item, index) in roleList" :value="item.id" :key="index">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <a-form-item>
                <a-select
                  :allowClear="true"
                  v-model="searchModel.status"
                  showSearch
                  optionFilterProp="children"
                  :filterOption="filterOption"
                  placeholder="请选择人员状态"
                >
                  <a-select-option v-for="(item, index) in statusList" :value="item.id" :key="index">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <!-- <a-col :span="24">
              <a-form-item>
                <a-select
                  :allowClear="true"
                  v-model="searchModel.groupIds"
                  mode="multiple"
                  :maxTagCount="3"
                  showSearch
                  optionFilterProp="children"
                  :filterOption="filterOption"
                  placeholder="请选择人员分组"
                >
                  <a-select-option v-for="(item, index) in groupList" :value="item.id" :key="index">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col> -->
            <!-- <a-col :span="24">
              <a-form-item>
                <a-select
                  :allowClear="true"
                  v-model="searchModel.projectIds"
                  mode="multiple"
                  :maxTagCount="3"
                  showSearch
                  optionFilterProp="children"
                  :filterOption="filterOption"
                  placeholder="请选择所属项目"
                >
                  <a-select-option v-for="(item, index) in baseProjectList" :value="item.id" :key="index">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col> -->
            <a-col :span="24">
              <a-form-item>
                <a-cascader
                  :fieldNames="{ label: 'name', value: 'id', children: 'children' }"
                  :options="deptList"
                  changeOnSelect
                  :showSearch="{ filter }"
                  placeholder="请选择组织机构"
                  v-model="searchModel.deptId"
                />
              </a-form-item>
            </a-col>
            <!-- <a-col :span="24">
              <a-form-item>
                <a-checkbox :checked="searchModel.withFile" @change="onChange">
                  导出用户附件信息
                </a-checkbox>
              </a-form-item>
            </a-col> -->
          </a-row>
        </a-form>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { exportBaseInfo } from '@/api/baseInfo'

export default {
  name: 'ExportModal',
  data () {
    return {
      width: 400,
      visible: false,
      btnLoading: false,
      spinning: false,
      searchModel: {
        roleIds: undefined,
        // groupIds: undefined,
        // projectIds: undefined,
        status: undefined,
        deptId: undefined
        // withFile: false
      },
      statusList: [
        // { id: 0, label: '待审核' },
        { id: 1, label: '正常' },
        // { id: 2, label: '待录入转岗卡' },
        { id: 4, label: '冻结' },
        { id: 9, label: '离职' }
      ]
    }
  },
  computed: mapGetters(['groupList', 'roleList', 'deptList']),
  beforeCreate () {
    this.form = this.$form.createForm(this, { name: 'export_form' })
  },
  mounted () {},
  methods: {
    // 点击查询按钮
    handleExport () {
      //   this.$emit('setSearchCondition', this.searchModel)
      // this.btnLoading = true
      // this.spinning = true

      const searchInfo = {}

      this.searchModel.roleIds = this.searchModel.roleIds && this.searchModel.roleIds.length !== 0 ? (searchInfo.roleIds = this.searchModel.roleIds.join(',')) : ''
      // this.searchModel.groupIds&&this.searchModel.groupIds.length!==0 ? (searchInfo.groupIds = this.searchModel.groupIds.join(',')) : ''
      // this.searchModel.projectIds ? (searchInfo.projectIds = this.searchModel.projectIds.join(',')) : ''
      // searchInfo.withFile = this.searchModel.withFile
      this.searchModel.status = (this.searchModel.status || this.searchModel.status === 0) ? (searchInfo.status = this.searchModel.status) : ''
      this.searchModel.deptId = this.searchModel.deptId && this.searchModel.deptId.length !== 0 ? (searchInfo.deptId = this.searchModel.deptId[this.searchModel.deptId.length - 1]) : ''

      exportBaseInfo(searchInfo)
        .then(res => {
          var blob = new Blob([res])
          var downloadElement = document.createElement('a')
          var href = window.URL.createObjectURL(blob)
          downloadElement.href = href
          // if (searchInfo.withFile) {
          //   downloadElement.download = '人员基础信息.zip'
          // } else {
          //   downloadElement.download = '人员基础信息.xlsx'
          // }
          downloadElement.download = '人员基础信息.xlsx'
          document.body.appendChild(downloadElement)
          downloadElement.click()
          document.body.removeChild(downloadElement)
          window.URL.revokeObjectURL(href)

          this.btnLoading = false
          this.spinning = false
        })
        .catch(err => {
          this.btnLoading = false
          this.spinning = false
        })
    },
    // 点击复位按钮
    clearSearch () {
      this.searchModel = {
        roleIds: undefined,
        // groupIds: undefined,
        // projectIds: undefined,
        status: undefined,
        // withFile: false,
        deptId: undefined
      }
    },
    // onChange(e) {
    //   this.searchModel.withFile = e.target.checked
    // },
    open (flag) {
      this.clearSearch()
      this.visible = flag
    },
    filterOption (input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    filter (inputValue, path) {
      return path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1)
    }
  }
}
</script>
